class QuickContactModal {
  constructor() {
    this.init();
  }

  init() {
    const userIsLoggedIn = Liferay.ThemeDisplay.isSignedIn();

    const formActionsElem = document.querySelector(
      ".quick-contact .btn-group.lfr-icon-actions"
    );
    const formPortletTopperElem = document.querySelector(
      ".quick-contact .portlet-topper"
    );
    const formPortletContentEditableElem = document.querySelector(
      ".quick-contact .portlet-content.portlet-content-editable"
    );

    if (!userIsLoggedIn) {
      formActionsElem?.classList.add("d-none");
      formPortletTopperElem?.classList.add("d-none");
      formPortletContentEditableElem?.classList.add("border-0");
    }

    Liferay.on("ddmFormView", () => {
      this.addCurrentUrlToHiddenField();
    });
  }

  /**
   * Add current page URL to a (hidden) form field with field reference 'WebsiteURL'.
   * This helps the bank to determine which topic might
   * have triggered user to use the contact form (BGD-338).
   */
  addCurrentUrlToHiddenField() {

    const formContainer = document.querySelector('.quick-contact .ddm-form-builder-app');
    if (!formContainer) {
      return;
    }

    const containerId = formContainer.id;

    const formComponent = Liferay.component(containerId);
    if (typeof formComponent === 'undefined') {
      return;
    }

    const hiddenUrlField = formComponent.reactComponentRef.current.getFields()
      .find((field) => field.fieldReference && field.fieldReference.toLowerCase() === 'websiteurl');
    if (typeof hiddenUrlField !== 'undefined') {
      hiddenUrlField.value = Liferay.currentURL;
    }
  }

}

export default QuickContactModal;
